






















































import { defineComponent, computed, inject, ref } from '@vue/composition-api'

// Store
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as InputStoreKey } from '@/store/Input'
import { StoreKey as ErrorStoreKey } from '@/store/Error'
import { StoreKey as ValidatedStoreKey } from '@/store/Validated'

// Util
import { useValidate } from '@/ts/util/validate'

type Props = {
    question: {
        ordered: string
        label: string
        is_checkbox: boolean
        answer?: {
            ordered: string
            label: string
            has_other_field: boolean
        }[]
    }
    answer: {
        ordered: string
        label: string
        has_other_field: boolean
    }
}

export default defineComponent({
    props: {
        question: { type: Object, required: true },
        answer: { type: Object, required: true },
    },
    setup(props: Props) {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }
        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }
        const validatedStore = inject(ValidatedStoreKey)
        if (!validatedStore) {
            throw new Error(`${ValidatedStoreKey} is not provided`)
        }

        const checkElement = ref<HTMLInputElement>(null)

        const validateHandler = useValidate(
            {
                required: ref(true),
            },
            (result, flag) => {
                validatedStore.question = {
                    ...validatedStore.question,
                    ...{ [props.question.ordered]: flag },
                }

                const messages: string[] = []
                if (result.required === false) {
                    messages.push(
                        (formStore.error_message.error_question || '').replace(
                            '%s',
                            props.question.ordered
                        )
                    )
                }

                if (messages.length) {
                    errorStore.question.value[props.question.ordered] = [
                        ...messages,
                    ]
                } else {
                    errorStore.question.value[props.question.ordered] = []
                }
            }
        )

        const inputFieldClass = computed(() => {
            return {
                'c-input-field-radio': !props.question.is_checkbox,
                'c-input-field-checkbox': props.question.is_checkbox,
                'm-invalid':
                    (props.question.ordered in errorStore.question.value &&
                        errorStore.question.value[props.question.ordered]) ||
                    validatedStore.question[props.question.ordered] === -1,
                'm-verify':
                    validatedStore.question[props.question.ordered] === 1,
            }
        })

        const onBlurOtherField = (e: FocusEvent) => {
            if ((e.target as HTMLInputElement).value) {
                if (checkElement.value && !checkElement.value.checked) {
                    checkElement.value.click()
                }
            }
        }

        return {
            checkElement,
            inputStore,
            validateHandler,
            inputFieldClass,
            onBlurOtherField,
        }
    },
})
